firebird.factory('meetingAPIService', [
    '$q',
    '$resource',
    '$timeout',
    '$location',
    'helperService',
    'logService',
    'config',
    'cookieService',
    'authService',
    function ($q, $resource, $timeout, $location, helperService, logService, config, cookieService, authService) {
        //TODO: paramDefaults are meant to populate ":variables" in the API endpoints...
        //since they are either meeting code or meeting shortcut URL, we can set them once
        //in this Service and use them for all API requests.
        //
        //That way, we don't need to pass them from the ctrls that call this service

        const logger = new LogServiceWrapper(logService, 'meetingAPIService');

        const endpoint = helperService.getAPIUrl() + '/meetings';

        const service = {
            getIsHost: getIsHost,
            processAuthExchange: processAuthExchange,
            getMeetingDetails: getMeetingDetails,
            getMeetingDetailsByCode: getMeetingDetailsByCode,
            getMeetingDetailsByShortcut: getMeetingDetailsByShortcut,
            joinBeforeHost: joinBeforeHost,
            setNewAttendee: setNewAttendee,
            getCurrentEndpoint: getCurrentEndpoint,
            getBrandingInfo: getBrandingInfo,
            getOnboardingInfo: getOnboardingInfo,
            setNewMeetingTitle: setNewMeetingTitle,
            updatedDiagnosticInfo: updatedDiagnosticInfo,
            sendAVQualityFeedback: sendAVQualityFeedback,
            validateHashedPassword: validateHashedPassword,
            getUserMetaInfo: getUserMetaInfo,
            getLiveChatConfigs: getLiveChatConfigs,

            _makeAPIRequest: makeAPIRequest
        };

        return service;

        ////////////////////////

        function getIsHost(params) {
            const deferred = $q.defer();
            const authToken = authService.getAuthToken();

            if (!authToken) {
                deferred.reject('No auth token.');
                return deferred.promise;
            }

            const paramDefaults = {
                meetingCode: '@meetingCode'
            };

            const actions = {
                get: {
                    headers: { Authorization: 'Bearer ' + authToken }
                }
            };

            const resource = $resource(endpoint + '/:meetingCode/host', paramDefaults, actions);
            const method = 'get';
            const args = [params];

            service
                ._makeAPIRequest(resource, method, args, 'getIsHost')
                .then(function (resp) {
                    if (resp && resp.data && resp.data.isHost) {
                        deferred.resolve(authToken);
                    } else {
                        deferred.reject('Could not validate user as host.');
                    }
                })
                .catch(function (err) {
                    logger.log('getIsHost', 'getIsHost request error:', err);
                    deferred.reject('Could not validate user as host.');
                });

            return deferred.promise;
        }

        function getUserMetaInfo() {
            const resource = $resource(helperService.getAPIUrl() + '/user/_me');

            return service._makeAPIRequest(resource, 'get');
        }

        function getLiveChatConfigs() {
            const resource = $resource(helperService.getAPIUrl() + '/oracleDigitalAssistant/LiveChatConfig');

            return service._makeAPIRequest(resource, 'get', undefined, 'getOracleLiveChatConfigs');
        }

        //This will check for meeting code OR shortcut url, depending
        //on the meeting identifier in current URL
        function getMeetingDetails() {
            const meetingIdentifier = helperService.getMeetingIdentifier($location.absUrl());
            let getMeetingDetailsFunctionName;
            let endpointParams;

            if (helperService.isValidMeetingCode(meetingIdentifier)) {
                getMeetingDetailsFunctionName = 'getMeetingDetailsByCode';
                endpointParams = { meetingCode: meetingIdentifier };
            } else if (helperService.isAlphanumeric(meetingIdentifier)) {
                // Possibly better to use isValidShortcut ^^^
                getMeetingDetailsFunctionName = 'getMeetingDetailsByShortcut';
                endpointParams = { meetingShortcutURL: meetingIdentifier };
            } else {
                logger.log('getMeetingDetails', 'Invalid meeting identifier... unable to get meeting details');

                const deferred = $q.defer();
                deferred.reject('Invalid meeting identifier');
                return deferred.promise;
            }

            return service[getMeetingDetailsFunctionName](endpointParams);
        }

        function getMeetingDetailsByCode(params) {
            const deferred = $q.defer();

            const paramDefaults = {
                meetingCode: '@meetingCode'
            };

            const resource = $resource(endpoint + '/:meetingCode/detail', paramDefaults);
            const method = 'get';
            const args = [params];

            service
                ._makeAPIRequest(resource, method, args, 'getMeetingDetailsByCode')
                .then(function (resp) {
                    //For backwards compatibility... this can be removed after 117.0 release
                    //New API response will have resp.data
                    //Old API response will just have resp
                    if (resp.data) {
                        deferred.resolve(resp.data);
                    } else {
                        deferred.resolve(resp);
                    }
                })
                .catch(function (err) {
                    logger.error('getMeetingDetailsByCode', 'Error', err);

                    deferred.reject(err.status + ' - Could not retrieve meeting details by code.');
                });

            return deferred.promise;
        }

        function getMeetingDetailsByShortcut(params) {
            const deferred = $q.defer();

            const paramDefaults = {
                meetingShortcutURL: '@meetingShortcutURL'
            };

            $resource(endpoint + '/shortcutURL/:meetingShortcutURL', paramDefaults)
                .get(params)
                .$promise.then(
                    function (meeting) {
                        deferred.resolve(meeting);
                    },
                    function (err) {
                        deferred.reject(err.data);
                    }
                );

            return deferred.promise;
        }

        function joinBeforeHost(meetingAccessCode, requestBody) {
            const deferred = $q.defer();
            const authToken = authService.getAuthToken();
            const actions = {
                save: {
                    method: 'POST',
                    headers: { Authorization: 'Bearer ' + authToken }
                }
            };
            const params = { meetingAccessCode: meetingAccessCode };
            $resource(endpoint + '/:meetingAccessCode/joinBeforeHost', params, actions)
                .save(params, requestBody)
                .$promise.then(meeting => {
                    deferred.resolve({ meeting: meeting, meetingWasActiveAlready: false });
                })
                .catch(error => {
                    switch (error.status) {
                        case 302:
                            deferred.resolve({ meeting: error.data, meetingWasActiveAlready: true });
                            break;
                        case 400:
                            if (
                                error.data.title === 'Not allowed to join before host' ||
                                error.data.title === 'Host has another active meeting'
                            ) {
                                deferred.reject(error.data);
                            } else {
                                deferred.reject({ message: 'skipJoinBeforeHost', details: error.data });
                            }
                            break;
                        case 401:
                        case 403:
                            deferred.reject({ message: 'skipJoinBeforeHost', details: error.data });
                            break;
                        case 500:
                            deferred.reject({ message: 'serverError', details: error.data });
                            break;
                        default:
                            deferred.reject(error.data);
                            break;
                    }
                });

            return deferred.promise;
        }

        function validateHashedPassword(meetingCode, hashedPassword) {
            const deferred = $q.defer();

            const actions = {
                save: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                }
            };

            const apiPath = '/:meetingCode/hashedPassword';
            const params = {
                meetingCode: meetingCode
            };
            const postData = {
                hashedPassword: hashedPassword
            };

            $resource(endpoint + apiPath, {}, actions)
                .save(params, postData)
                .$promise.then(
                    function () {
                        deferred.resolve(true);
                    },
                    function () {
                        deferred.resolve(false);
                    }
                );

            return deferred.promise;
        }

        function setNewAttendee(params, postData) {
            const deferred = $q.defer();

            const actions = {
                save: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                }
            };

            let apiPath;
            const authToken = authService.getAuthToken();
            if (helperService.isVideoRoomApplication()) {
                apiPath = '/:meetingCode/attendees/roomlogin';

                if (!authToken) {
                    deferred.reject('No auth token.');
                    return deferred.promise;
                }
            } else {
                apiPath = postData.isHost ? '/:meetingCode/attendees/hostlogin' : '/:meetingCode/attendees/login';
            }

            // need to pass auth token to determine is attendee trusted or not
            if (authToken) {
                actions.save.headers.Authorization = 'Bearer ' + authToken;
            }

            $resource(endpoint + apiPath, {}, actions)
                .save(params, postData)
                .$promise.then(
                    function (attendee) {
                        deferred.resolve(attendee);
                    },
                    function (err) {
                        let errMsg = 'Could not set new attendee.';

                        if (err && err.data && err.data.message) {
                            errMsg = err.data.message;
                        }

                        deferred.reject(errMsg);
                    }
                );

            return deferred.promise;
        }

        function getCurrentEndpoint() {
            return endpoint;
        }

        function getBrandingInfo(params) {
            const deferred = $q.defer();

            const paramDefaults = {
                meetingCode: '@meetingCode'
            };

            $resource(endpoint + '/:meetingCode/branding-info', paramDefaults)
                .get(params)
                .$promise.then(
                    function (resp) {
                        //For backwards compatibility... this can be removed after 117.0 release
                        //New API response will have resp.data
                        //Old API response will just have resp
                        if (resp.data) {
                            deferred.resolve(resp.data);
                        } else {
                            deferred.resolve(resp);
                        }
                    },
                    function (err) {
                        deferred.reject('Error ' + err.status + ': - ' + err.message);
                    }
                );

            return deferred.promise;
        }

        function getOnboardingInfo(params) {
            const deferred = $q.defer();

            const paramDefaults = {
                meetingCode: '@meetingCode'
            };

            $resource(endpoint + '/:meetingCode/onboarding', paramDefaults)
                .get(params)
                .$promise.then(
                    function (result) {
                        deferred.resolve(result);
                    },
                    function (err) {
                        deferred.reject(err.message + ' - Could not retrieve onboarding info.');
                    }
                );

            return deferred.promise;
        }

        /*  check the query string for the api auth parameters ... if not present, simply resolve the promise
            if present, run the exchange through the rest api and set the local cookies with the value present
            in the return.

            Auth parameters are
            ip_uid=xxx
            tk=xxx
            origin=api

        */
        function processAuthExchange(params) {
            const deferred = $q.defer();

            const authToken = authService.getAuthToken();

            //TODO: we may have to do this differently at some point as it will not pass somone to a different account
            //      when using the api
            if (authToken) {
                deferred.reject('processAuthExchange found user already authorized with aat');
                return deferred.promise;
            }

            const ip_uid = helperService.getQueryParameter('ip_uid');
            const tk = helperService.getQueryParameter('tk');
            const origin = helperService.getQueryParameter('origin');

            if (!ip_uid || !tk || !origin) {
                deferred.reject('missing or bad parameter in auth exchange');
                return deferred.promise;
            }

            if (origin !== 'api') {
                deferred.reject('missing or bad origin parameter in auth exchange');
                return deferred.promise;
            }

            const paramDefaults = {
                meetingCode: '@meetingCode'
            };

            params.ip_uid = ip_uid;
            params.tk = tk;

            const actions = {
                save: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                }
            };

            $resource(endpoint + '/:meetingCode/authexchange', paramDefaults, actions)
                .save(params)
                .$promise.then(function (result) {
                    setAuthCookies(result);
                    deferred.resolve();
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function setAuthCookies(data) {
            const opts = {
                domain: helperService.getLocationHost(),
                secure: true,
                samesite: 'lax'
            };

            if (data.aat) {
                cookieService.put('aat', data.aat, opts);
            }

            //we are setting this value directly to a cookie instead of using the angular $cookies
            //service because the URI encoding performed by that service doesn't match the encoding we need
            //for this am_auth value and is not overrideable (and you can't skip the encoding)
            //TODO: need to refactor this into something more testable
            if (data.am_ext) {
                // [SBELIKOV] TODO: need to delete this code after https://jira.imsecurityproducts.net/browse/ANYAM-72077
                const cookieString = 'am_ext=' + data.am_ext + ';domain=' + opts.domain;
                document.cookie = cookieString;
            }
        }

        function setNewMeetingTitle(params) {
            const deferred = $q.defer();

            const paramDefaults = {
                meetingCode: '@meetingCode'
            };

            const actions = {
                save: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                }
            };

            $resource(endpoint + '/:meetingCode', paramDefaults, actions)
                .save(params)
                .$promise.then(
                    function (resp) {
                        deferred.resolve();
                    },
                    function (err) {
                        let errMsg = 'Unable to update meeting title.';

                        if (err && err.data && err.data.message) {
                            errMsg = err.data.message;
                        }

                        deferred.reject(errMsg);
                    }
                );

            return deferred.promise;
        }

        function updatedDiagnosticInfo(params) {
            const deferred = $q.defer();

            const paramDefaults = {
                meetingCode: params.meetingCode
            };

            const actions = {
                update: {
                    method: 'PUT',
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }
            };

            const fd = new FormData();
            fd.append('file', params.file);
            fd.append('diagnosticStats', JSON.stringify(params.stats));
            fd.append('attendantId', params.attendantId);
            fd.append('responseGuid', params.responseGuid);

            $resource(endpoint + '/:meetingCode/diagnostic', paramDefaults, actions)
                .update(fd)
                .$promise.then(
                    function (resp) {
                        deferred.resolve();
                    },
                    function (err) {
                        let errMsg = 'Unable to update diagnostic information.';

                        if (err && err.data && err.data.message) {
                            errMsg = err.data.message;
                        }

                        logger.error('updatedDiagnosticInfo', 'Error', err);

                        deferred.reject(errMsg);
                    }
                );

            return deferred.promise;
        }

        function sendAVQualityFeedback(params) {
            //Example params:
            // {
            //     meetingCode: (meeting code),
            //     attendantId: (attendant id),
            //     overall: (overall score),
            //     audio: (audio score,
            //     video: (video score),
            //     comment: (comment)
            // }

            const deferred = $q.defer();

            const paramDefaults = {
                meetingCode: params.meetingCode
            };

            const actions = {
                update: {
                    method: 'PUT',
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }
            };

            const fd = new FormData();
            fd.append('attendantId', params.attendantId);
            fd.append('overallScore', params.overall);
            fd.append('audioScore', params.audio);
            fd.append('videoScore', params.video);
            fd.append('comment', params.comment);

            $resource(endpoint + '/:meetingCode/diagnostic', paramDefaults, actions)
                .update(fd)
                .$promise.then(
                    function (resp) {
                        deferred.resolve();
                    },
                    function (err) {
                        let errMsg = 'Unable to send AV quality feedback';

                        if (err && err.data && err.data.message) {
                            errMsg = err.data.message;
                        }

                        logger.error('sendAVQualityFeedback', 'Error', err);

                        deferred.reject(errMsg);
                    }
                );

            return deferred.promise;
        }

        //Helper function to take care of retry logic if requests fail due to timeouts...
        //If no timeout, bubble the resolve/reject params back to original caller
        function makeAPIRequest(resource, method, args, apiCallName) {
            const deferred = $q.defer();

            retryRequest(1);

            function retryRequest(tryAttemptNumber) {
                //If no tryAttemptNumber value, default to 'first try'
                tryAttemptNumber = tryAttemptNumber || 1;

                //If first try, timeBeforeRetry will be 0.
                //Afterwards, it will be 1 second, then 2 seconds, then 4, etc... with max of 30 seconds
                let timeBeforeRetry = tryAttemptNumber === 1 ? 0 : Math.pow(2, tryAttemptNumber - 2) * 1000;

                if (timeBeforeRetry > 30000) {
                    timeBeforeRetry = 30000;
                }

                $timeout(function () {
                    resource[method]
                        .apply(this, args)
                        .$promise.then(deferred.resolve)
                        .catch(function (err) {
                            if (err && err.status === -1) {
                                //Timed out... try again
                                const newAttemptNumber = tryAttemptNumber + 1;
                                logger.log(
                                    apiCallName,
                                    '- Request timed out... attempting retry number:',
                                    newAttemptNumber
                                );
                                retryRequest(newAttemptNumber);
                            } else {
                                deferred.reject(err);
                            }
                        });
                }, timeBeforeRetry);
            }

            return deferred.promise;
        }
    }
]);
